import qs from 'qs';
import Pagination from 'core/models/pagination';
import OrcamentoEndereco from 'core/models/POC/orcamentoEnrereco';
import api from '../api';

const baseURL = `/POC/PocOrcamentoEndereco`;

export const getOrcamentoEnderecoList = async (filters) => {
  const response = await api.get(`${baseURL}/OrcamentoEndereco/Search`, {
    params: filters,
  });
  const { status, message, value } = response.data ?? {};

  return {
    status,
    message,
    data: value?.map((json) => new OrcamentoEndereco(json)) ?? [],
  };
};

export const getOrcamentoEnderecoPagined = async (filters) => {
  const response = await api.get(`${baseURL}/SearchPagined`, {
    params: filters,
  });
  const { status, message, value, pagination } = response.data ?? {};

  return {
    status,
    message,
    data: value?.map((json) => new OrcamentoEndereco(json)) ?? [],
    pagination: new Pagination(pagination),
  };
};

export const getOrcamentoEndereco = async (id) => {
  const response = await api.get(`${baseURL}/`, {
    params: { id },
  });
  const { value } = response.data ?? {};
  return value ? new OrcamentoEndereco(value) : {};
};

export const postOrcamentoEnderecoListOrder = async (data) => {
  const response = await api.post(`${baseURL}/Order`, data);

  const { status, message, value } = response.data ?? {};

  return {
    status,
    message,
    data: value?.map((json) => new OrcamentoEndereco(json)) ?? [],
  };
};

export const saveOrcamentoEndereco = async (data) => {
  const response = await api.post(`${baseURL}/`, data);
  return response.data ?? {};
};

export const deleteOrcamentoEndereco = async (id) => {
  const response = await api.delete(`${baseURL}/`, { params: { id } });
  return response.data ?? {};
};

export const printOrcamentoEndereco = async (filters) => {
  const response = await api.get(`${baseURL}/Print`, {
    params: filters,
  });
  return response.data ?? {};
};

export const excelOrcamentoEndereco = async (filters) => {
  const response = await api.get(`${baseURL}/Excel`, {
    params: filters,
  });
  return response.data ?? {};
};

export const deleteAllOrcamentoEndereco = async (ids) => {
  const response = await api.delete(`${baseURL}/DeleteAll`, {
    params: { ids },
    paramsSerializer: (params) => qs.stringify(params),
  });
  return response.data ?? {};
};
